import React, { useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "../SelectValue/Button";
import WestIcon from "@mui/icons-material/West";
import FundWalletPin from "./Pins";
import postService from "../../Services/post-service";
import { toast } from "react-toastify";
import WalletSuccess from "./WalletSuccess";
import NonnegativeInputField from "../SelectValue/NonnegativeInputfield";
import { useNavigate } from "react-router-dom";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  height: "60%",
  bgcolor: "#FFFFFF",
  boxShadow: 24,
};

function Withdrawal({ open, handleClose, handleBack, bank }) {
  const [opeen, setOpeen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [successAmount, setSuccessAmount] = useState("");
  const [amount, setAmount] = useState("");
  const [oopen, setOopen] = useState(false);
  const navigate = useNavigate();
  const handleCloose = () => setOpeen(false);

  const handleClooose = () => {
    setOopen(false);
    handleClose();
    window.dispatchEvent(new Event("walletRefresh"));
  };
  const [pin, setPin] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    setOpeen(true);
  };
  const FinalSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    postService
      .requestWithdrawal(amount, bank?.id)
      .then((res) => {
        setLoading(false);
        if (res?.data?.statusCode === 200) {
          setSuccessAmount(amount);
          setOpeen(false);
          setOopen(true);
          setAmount("");
        } else {
          toast.error(res?.data?.description || "Request failed");
        }
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.description || "An error occurred");
      });
  };
  return (
    <div>
      <FundWalletPin
        open={opeen}
        handleClose={handleCloose}
        loading={loading}
        pin={pin}
        setPin={setPin}
        onSubmit={FinalSubmit}
      />
      <WalletSuccess
        open={oopen}
        handleClose={handleClooose}
        header="Withdrawal request submitted"
        con={
          <p>
            Your withdrawal request of
            <span className="text-back-color2 font-[500] mx-2">
              NGN {successAmount}
            </span>
            has been submitted for review. Funds will be transferred to your
            bank account once approved
          </p>
        }
      />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box sx={style} className=" rounded-lg p-6 pt-10">
            <div className=" h-[40vh] ">
              <div className="">
                <div className=" flex justify-between mb-3">
                  <div
                    className="cursor-pointer flex items-center gap-1"
                    onClick={handleBack}
                  >
                    <WestIcon /> <span className="pl-2">Back</span>
                  </div>
                  <div>
                    <CancelIcon
                      onClick={handleClose}
                      className=" text-back-color2 cursor-pointer text-[38px]"
                      fontSize="large"
                    />
                  </div>
                </div>
                <div className=" mt-7">
                  <form onSubmit={onSubmit}>
                    <NonnegativeInputField
                      title="Enter withdrawal amount"
                      label="Enter amount(NGN)"
                      valuee={amount}
                      onChange={setAmount}
                    />
                    <div className=" grid grid-cols-1 mb-5 mt-6">
                      <Button name="Withdraw" />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}

export default Withdrawal;
